import { SupportPlanDTO } from '../../../src_server/entity/dto/SupportPlanDTO';


import { PlanTarget } from '../../../src_server/entity/generated/PlanTarget';


import { UserSupportPlanDTO } from '../../../src_server/entity/dto/UserSupportPlanDTO';


import { DaSelectedCourse } from '../../../src_server/entity/generated/DaSelectedCourse';


import { SupportPlanAttach } from '../../../src_server/entity/generated/SupportPlanAttach';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';


import { Student } from '../../../src_server/entity/generated/Student';


import { Communicate } from '../../../src_server/entity/generated/Communicate';export class SupportPlanService extends GeneratedBizBase{
  async getSupportPlan(support_plan_id: number): Promise<Response<SupportPlanDTO>> {
    return super.restCall<Response<SupportPlanDTO>>('get', '/v1/SupportPlanService/getSupportPlan', arguments);
  }
  async getPlanByDate(user_id: string,lesson_dt: Date): Promise<Response<PlanTarget[]>> {
    return super.restCall<Response<PlanTarget[]>>('post', '/v1/SupportPlanService/getPlanByDate', arguments);
  }
  async getPlan(user_id: string): Promise<Response<SupportPlanDTO[]>> {
    return super.restCall<Response<SupportPlanDTO[]>>('get', '/v1/SupportPlanService/getPlan', arguments);
  }
  async addPlan(user_id: string): Promise<Response<SupportPlanDTO>> {
    return super.restCall<Response<SupportPlanDTO>>('post', '/v1/SupportPlanService/addPlan', arguments);
  }
  async copyPlan(originalDTO: SupportPlanDTO): Promise<Response<SupportPlanDTO>> {
    return super.restCall<Response<SupportPlanDTO>>('post', '/v1/SupportPlanService/copyPlan', arguments);
  }
  async deletePlan(plan_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/SupportPlanService/deletePlan', arguments);
  }
  async updatePlan(plan: SupportPlanDTO): Promise<Response<SupportPlanDTO>> {
    return super.restCall<Response<SupportPlanDTO>>('post', '/v1/SupportPlanService/updatePlan', arguments);
  }
  async getByUserId(id: string): Promise<Response<UserSupportPlanDTO>> {
    return super.restCall<Response<UserSupportPlanDTO>>('post', '/v1/SupportPlanService/getByUserId', arguments);
  }
  async updateStudentInfo(id: string,student: Student,communicate: Communicate): Promise<Response<boolean>> {
    return super.restCall<Response<boolean>>('post', '/v1/SupportPlanService/updateStudentInfo', arguments);
  }
  async getUserCourses(student_user_id: string): Promise<Response<DaSelectedCourse[]>> {
    return super.restCall<Response<DaSelectedCourse[]>>('get', '/v1/SupportPlanService/getUserCourses', arguments);
  }
  async addFileOrComment(stu_user_id: string,user_id: string,comment: string,filePaths: string[]): Promise<Response<SupportPlanAttach[]>> {
    return super.restCall<Response<SupportPlanAttach[]>>('post', '/v1/SupportPlanService/addFileOrComment', arguments);
  }
  async getFileOrComment(support_plan_id: number): Promise<Response<any>> {
    return super.restCall<Response<any>>('get', '/v1/SupportPlanService/getFileOrComment', arguments);
  }
  async getFileOrCommentByUser(user_id: string): Promise<Response<any>> {
    return super.restCall<Response<any>>('get', '/v1/SupportPlanService/getFileOrCommentByUser', arguments);
  }
  async deleteFileOrComment(support_plan_attache_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/SupportPlanService/deleteFileOrComment', arguments);
  }
}
